import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";

import { toast } from "react-toastify";
import Pagination from "../../../../components/Pagination";
import Modal from "react-modal";
import { Modal as AntModal, Spin } from "antd";
import moment from "moment";

const SampleApprovalList = (props) => {
  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  const [deleteLoading, setDeleteLoading] = useState(false);
  
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "450px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const [paramterDetail, setParamterDetail] = useState();

  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [approvalData, setApprovalData] = useState([]);

  const openModal = (data) => {
    // //console.log(data);

    const seedABAgencyId = data && data.seedABAgencyId;

    getTestApproval(
      {
        url: `/api/seedApprovalByAgency/?seedABAgencyId=${seedABAgencyId}`,
      },
      (res) => {
        //  //console.log(res);
        setParamterDetail(res && res.paramterDetail);
      }
    );

    setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const { sendRequest: getTestApproval } = useHttp();

  const getData = () => {
    getTestApproval(
      {
        url: `/api/seedApprovalByAgency/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${localStorage.getItem("warehouseId")}`,
      },
      (res) => {
        // //console.log(res);
        const sortedData = res.sort(
          (a, b) => b.seedABAgencyId - a.seedABAgencyId
        );

        setData(sortedData);
        setApprovalData(sortedData);
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata =
      approvalData &&
      approvalData.filter(
        (item) =>
          item?.seedABAgencyNo?.includes(filetrtext) ||
          item?.lotNo?.includes(filetrtext)
      );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    console.log(expense);
    setSelectedApprovalData(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        itemId: selectedApprovalData && selectedApprovalData.seedABAgencyId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    // console.log(data);

    updateApprovalStatus(
      {
        url: "/api/approveSeedApprovalByAgency/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);

        setApprovalPopupVisible(false);
        setRemark("");
        getData();

        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              Sample Approval by Authorized organization
            </label>
          </div>

          <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Sample Approval
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Sample Approval Date</th>
                          <th>InspectionTime</th>
                          <th>Doc No</th>
                          <th>Lot No</th>
                          <th>Inspected By</th>
                          <th>Approval</th>

                          {canDelete === "block" && <th>Delete</th>}
                          {canView === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.seedApprovalDate}</td>
                                <td>
                                  {moment(itm.timeStamp, "HH:mm:ss").format(
                                    "hh:mm A"
                                  )}
                                </td>
                                <td>{itm.seedABAgencyNo}</td>
                                <td>{itm.lotNo}</td>
                                <td>{itm.employeeName}</td>

                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(itm)}
                                    disabled={
                                      itm.nextlevel == 1
                                        ? itm.allowApproveUserId == loginUserId
                                          ? false
                                          : true
                                        : itm.approved == 0 &&
                                          itm.reportingId == loginUserId
                                        ? false
                                        : true
                                    }
                                  >
                                    {itm.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : itm.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                {canDelete === "block" && (
                                  <td>
                                    <button
                                      type="button"
                                      //   onClick={(e) => handleDelete(e, itm)}
                                      className="btn"
                                      disabled={deleteLoading}
                                    >
                                      {deleteLoading ? (
                                        <Spin size="small" />
                                      ) : (
                                        <i className="fa fa-trash"></i>
                                      )}
                                    </button>
                                  </td>
                                )}
                                {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(itm)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="">
          <h3 className="card-title">
            Sample Approval by Authorized organization Details
          </h3>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setIsModalOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
        </div>
        {selectedData && (
          <div className="">
            <div className="row">
              <p className="col-md-6">Date: {selectedData.seedApprovalDate}</p>
              <p className="col-md-6">
                Time:
                {moment(selectedData.timeStamp, "HH:mm:ss").format("hh:mm A")}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Doc No: {selectedData.seedABAgencyNo}</p>
              <p className="col-md-6">
                Inspected By: {selectedData.employeeName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Lot No: {selectedData.lotNo}</p>
              <p className="col-md-6">
                Sample Quantity: {selectedData.sampleQty}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Unit: {selectedData.unitAbbreviation}</p>
              <p className="col-md-6">
                Temperature(°C): {selectedData.temperature}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Product Name: {selectedData.inputProductName}
              </p>

              <p className="col-md-6">Crop Name: {selectedData.cropName}</p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Variety Name: {selectedData.varietyName}
              </p>
              <p className="col-md-6">Result: {selectedData.result}</p>
            </div>

            <h5>Observation Paramter Details</h5>
            <table className="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Paramter Name</th>

                  <th>Observation</th>
                </tr>
              </thead>
              <tbody>
                {paramterDetail &&
                  paramterDetail.map((itm, i) => {
                    return (
                      <tr key={i} className="cursor-pointer">
                        <td>{i + 1}</td>
                        <td>{itm.parameterName}</td>
                        <td>{itm.observation}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>

      <AntModal
        title="Sample Approval by Authorized organization Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default SampleApprovalList;
